import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TabMenu } from 'primereact/tabmenu';
import { MenuItem } from 'primereact/menuitem';
import { getAction } from '../../../appconfig/AppHelper';

export const VerificationTab = (initialTabLabel: any) => {
    const router = useNavigate();

    const [actions, setActions] = useState<any>([]);
    const [activeIndex, setActiveIndex] = useState<number>(0);

    const HRitems: MenuItem[] = [
        {
            label: 'RHUS Verification Letters',
            command: () => {
                router('/app/letters/ruhs-letter');
            }
        },
        {
            label: 'NIOS Verification Letters',
            command: () => {
                router('/app/letters/nios-letter');
            }
        },
        {
            label: 'University Verification Letters',
            command: () => {
                router('/app/letters/verification-university');
            }
        },
        {
            label: 'Board Verification Letters',
            command: () => {
                router('/app/letters/verification-board');
            }
        },
        {
            label: 'College Verification Letters',
            command: () => {
                router('/app/letters/verification-college');
            }
        },
        {
            label: 'School Verification Letters',
            command: () => {
                router('/app/letters/verification-school');
            }
        },
        {
            label: 'Gujarat Other Councils',
            command: () => {
                router('/app/letters/gujarat-other-councils');
            }
        },
    ];

    const filteredHRitems = HRitems.filter((item) => item.label && Object.prototype.hasOwnProperty.call(actions, item.label));

    // use Effect method
    useEffect(() => {
        setActions(getAction('Verification Letters'));
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    useEffect(() => {
        if (filteredHRitems.length > 0 && initialTabLabel) {
            const foundIndex = filteredHRitems.findIndex((item) => item.label == initialTabLabel.initialTabLabel);
            setActiveIndex(foundIndex >= 0 ? foundIndex : 0);
        }
    }, [actions, filteredHRitems]);


    return (
        <>
            <TabMenu model={filteredHRitems} activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} className="general-tab inner-tab " />
        </>
    );
};
